export default "images/sample_avatar.svg";